import { Fragment } from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';
import PropTypes from 'prop-types';

const propTypes = {
  invoiceFrom: PropTypes.string.isRequired,
};

const InvoiceFrom = ({ invoiceFrom }) => {
  return (
    <Fragment>
      <View style={styles.invoiceFrom}>
        <Text style={styles.invoiceFromText}>{invoiceFrom}</Text>
      </View>
    </Fragment>
  );
};

InvoiceFrom.propTypes = propTypes;

export default InvoiceFrom;
